<template>

    <header id="header" ref="header" :class="{'narrow': !layout_wide}">

        <button id="menu-toggle" title="Vis menu" @click="toggleMenu()" v-if="!layout_wide">
            <span class="bar"></span>
            <span class="bar"></span>
            <span class="bar"></span>
        </button>

        <div class="nav-global-container" v-if="layout_wide || display_menu" @click="toggleMenu()">
            <nav class="nav-global">
                <div>
                    <router-link v-if="user.is_staff && auth" to="/dashboard" class="btn">Overblik</router-link>
                    <router-link to="/search" class="btn">Søg lokaler</router-link>
                    <template class="nav-auth" v-if="auth">
                        <router-link v-if="user.is_staff" to="/bookinglist" class="btn">Søg reservationer</router-link>
                        <router-link to="/my-bookings" class="btn">Mine reservationer</router-link>
                        <router-link to="/profile" class="btn">Profil</router-link>
                    </template>  
                </div>
                <div v-if="!auth">
                    <router-link to="/signup" class="btn">Opret ny bruger</router-link>
                    <router-link to="/signin" class="btn">Log ind</router-link>
                </div>
                <button v-if="auth" @click="logout()">Log ud</button>
            </nav>
        </div>

    </header>

</template>

<script>

    import userActions from '../auth/UserActions.vue'

    export default {
        
        components: {
            userActions
        },
        data: function() {
            return {
                display_menu: false,
                width: null
            }
        },
        computed: {
            auth: function() {
                return this.$store.getters.isAuthenticated
            },
            user: function() {
                return this.$store.getters.getUser
            },
            layout_wide: function() {
                if (this.width > 600) {
                    return true
                } else {
                    return false
                }
            }
        },
        methods: {
            toggleMenu: function() {
                this.display_menu = !this.display_menu
            },
            logout: function() {
                this.$store.dispatch('logout')
            }
        },
        mounted: function() {
            this.width = this.$refs.header.clientWidth

            
        }
    }

</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    #header {
        background-color: $grey1;
        flex-shrink: 0;
        width: 100%;
        
        a,
        button {
            background-color: $grey2;
            border: none;
            margin: 0 1px 0 0;
            flex-grow: 0;
        }
        .nav-global {
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            padding: .5rem 1rem;
        }
        #menu-toggle {
            display: none;
        }
    }

    #header.narrow {

        
        .nav-global-container {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: hsla(0,0%,0%,.66);
            z-index: 1000;
        }
        .nav-global {
            display: block;
            min-width: 15rem;
            position: fixed;
            top: 0;
            left: 0;
            background-color: $grey1;
            padding: 0;
            height: 100%;

            a, 
            button {
                padding: 1rem;
                margin: 0 0 1px 0;
                display: block;
                width: 100%;
                text-align: left;
            }
        }
        #menu-toggle {
            display: block;
            border-radius: none;
            
            .bar {
                display: block;
                width: 1.25rem;
                height: .125rem;
                background-color: $grey10;
                margin: .25rem 0;
            }
        }
    }

</style>
